import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BakerySetup.module.css";
import Switch from "../../../../components/Switch/Switch";
import { Modal, SubmitButton, TextComponent } from "../../../../components";
import { t } from "i18next";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";

const BakerySetup = () => {
  const navigate = useNavigate();
  const [saveModal, setSaveModal] = useState(false);

  const ProductionStations = [
    {
      id: 1,
      name: "Mixing ",
    },
    {
      id: 2,
      name: "Make Up  ",
    },
    {
      id: 3,
      name: "Proofing ",
    },
    {
      id: 4,
      name: "Oven ",
    },
    {
      id: 5,
      name: "Chilling ",
    },
    {
      id: 6,
      name: "Packaging ",
    },
    {
      id: 7,
      name: "Assembly ",
    },
  ];
  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={"Bakery Setup"}
        submitButtonText={"Save"}
        showSubmitButton={true}
        onSubmit={() => setSaveModal(true)}
        //  onSubmit={() => {
        //   const confirmed = window.confirm("Are you sure you want to save and go home?");
        //   if (confirmed) {
        //     navigate("/");
        //   }
        // }}
      />

      <div className={styles.subCont}>
        <div className={styles.leftCont}>
          <TextComponent
            text={t("Production Stations ")}
            padding={"0px"}
            className={styles.Heading}
            //             className={styles.Heading}
          />
          <div className={styles.Box}>
            {ProductionStations.map((item, index) => {
              return (
                <div key={item?.id} className={styles.ItemDiv}>
                  <Switch
                    SwitchContainerStyle={styles.SwitchContainerStyle}
                    label={item?.name}
                    SwitchLabelStyle={styles.SwitchLabelStyle}
                    defaultChecked
                    size="small"
                    inactiveColor={"var(--switch-Inactive-color)"}
                    activeColor={"var(--switch-active-color)"}
                  />
                </div>
              );
            })}
          </div>
          <TextComponent
            text={t("Task Assignment Mode")}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Station-Based: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "All tasks are assigned to the entire department and all staff involved."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"User-Based: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={"Individual Staff members are assigned to a task."}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>

          <TextComponent
            text={t("Staff Self-Assignment")}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Enabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Staff can select any task from their department queue."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled:"}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Tasks are visible only once assigned by a Supervisor"
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
        </div>
        <div className={styles.rightCont}>
          <TextComponent
            text={"Mixing Station Configuration"}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Single Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "One shared Mixing station for both bread and pastry."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <TextComponent
            text={t("Make Up Station Configuration")}
            className={styles.Heading}
          />
          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Single Make Up Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "One shared Make Up Station for both bread and pastry."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <TextComponent text={t("Waste Logging")} className={styles.Heading} />
          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Enabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={"All Staff can log waste"}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={"Waste can only be logged by Supervisors."}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <TextComponent
            text={t("Measurement Units")}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Metric System: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={"Kilograms, Celsius, Liters, etc."}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Imperial System: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={"Pounds, Fahrenheit, Gallons, etc."}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                SwitchContainerStyle={styles.SwitchContainerStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <TextComponent
            text={t("Instruction Checklist")}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Enabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Staff will need to check all recipe instructions during production to complete the order."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Instructions will only be present for reference during production."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <TextComponent
            text={t("Compliance Checklist")}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Enabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Staff will need to check all compliance policies during production to complete the order."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Policies will only be present for reference during production."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
          <TextComponent
            text={t("Production Schedule Merging")}
            className={styles.Heading}
          />

          <div className={styles.Box}>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Dual Station Mode: "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Separate stations for Mixing (Bread) and Mixing (Pastry)."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
            <div className={styles.ItemDiv}>
              <Switch
                Twolabel
                labelTitle={"Disabled:  "}
                SwitchLabelTitleStyle={styles.SwitchLabelTitleStyle}
                labelDesc={
                  "Each task will be treated as a unique task on the schedule."
                }
                SwitchContainerStyle={styles.SwitchContainerStyle}
                SwitchlabelDescStyle={styles.SwitchlabelDescStyle}
                defaultChecked
                size="small"
                inactiveColor={"var(--switch-Inactive-color)"}
                activeColor={"var(--switch-active-color)"}
              />
            </div>
          </div>
        </div>
      </div>

      {/* //////////////////////////  delete modal ///////////////////////// */}
      <Modal
        open={saveModal}
        // onCancel={() => setDeleteModal(false)}
        className={styles.modalCont}
        title={"Saved successfully"}
        buttonTitle={"Ok"}
        onBtnPress={() => setSaveModal(false)}
        btnStyle={{ width: "200px" }}
        // twoButton={true}
        // okBtnTitle={"Yes"}
        // cancelBtnTitle={"No"}
        onCancel={() => {
          setSaveModal(false);
        }}
        onClickOkButton={() => {
          setSaveModal(false);
        }}
        onClickCancelButton={() => {
          setSaveModal(false);
        }}
        //  onClickOkButton={setDeleteModal(false)}
        // onClickCancelButton={setDeleteModal(false)}
      ></Modal>
    </div>
  );
};

export default BakerySetup;
